/**
 * @class
 */
import Base from './assetConstituents_';
import Model from '../models/assetConstituent_keyframe';

export default class AssetConstituents_Keyframes extends Base {
	/** @type {string} */
	get type() {
		return 'keyframes';
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituents_Keyframes';
	}
}
